export default __webpack_public_path__ + "static/media/blockchain-blog.93cd02ca.svg";